import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_FRZ_67 } from "@/lib/programs/fezMarrakech67";

export default function FezMarrakech67Page() {
  return <ProgramTemplate program={PROGRAM_FRZ_67} variant="frz" showJourneyChronology />;
}
